module.exports = function(el) {

  var c;

  while (el.childNodes.length) {
    c = el.childNodes[0];
    el.removeChild(c);
  }

  return el;
};


// WEBPACK FOOTER //
// ./~/min-dom/lib/clear.js